module.exports = __webpack_public_path__ + "static/media/conf-app2.0b31b8cd.png";